"use client";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState: CartState = (() => {
  if (typeof window !== "undefined") {
    // Asegura que está en el cliente

    const persistedState = localStorage.getItem("__redux__cart__");
    if (persistedState !== null) {
      return JSON.parse(persistedState);
    } else {
      return {
        items: [],
        total: 0,
        totalQuantity: 0,
        id_delivery_type: 0,
        status: "pendiente",
      };
    }
  } else {
    return {
      items: [],
      total: 0,
      totalQuantity: 0,
      id_delivery_type: 0,
      status: "pendiente",
    };
  }
})();

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<CartItem>) => {
      const existingItem = state.items.find(
        (item) => item.id_product === action.payload.id_product
      );
      if (existingItem) {
        existingItem.quantity += 1;
        existingItem.total_price = existingItem.price * existingItem.quantity;
      } else {
        state.items.push({
          ...action.payload,
          quantity: 1,
          total_price: action.payload.price,
        });
      }
      state.total = state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );
      state.totalQuantity = state.items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );
      toast.success("Producto agregado al carrito!");
    },

    removeItem: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter(
        (item) => item.id_product !== action.payload
      );
      state.total = state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );
      state.totalQuantity = state.items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );
      toast.error("El producto se ha removido del carrito!");
    },
    increaseQuantity: (state, action: PayloadAction<number>) => {
      const existingItem = state.items.find(
        (item) => item.id_product === action.payload
      );
      if (existingItem) {
        existingItem.quantity += 1;
        existingItem.total_price = existingItem.price * existingItem.quantity;
      }
      state.total = state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );
      state.totalQuantity = state.items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );
      toast.info("Se ha actualizado la cantidad de producto!");
    },
    setDeliveryType: (state, action: PayloadAction<number>) => {
      state.id_delivery_type = action.payload;
    },
    decreaseQuantity: (state, action: PayloadAction<number>) => {
      const existingItem = state.items.find(
        (item) => item.id_product === action.payload
      );
      if (existingItem && existingItem.quantity > 1) {
        existingItem.quantity -= 1;

        existingItem.total_price = existingItem.price * existingItem.quantity;
      }
      state.total = state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );
      state.totalQuantity = state.items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );
      toast.info("Se ha actualizado la cantidad de producto!");
    },
    addAdicionalCost: (state, action: PayloadAction<number>) => {
      state.total += action.payload;
    },
    /*  updateQuantity: (
      state,
      action: PayloadAction<{ id_product: number; quantity: number }>
    ) => {
      const item = state.items.find(
        (item) => item.id_product === action.payload.id_product
      );
      if (item) {
        item.quantity = Math.max(0, action.payload.quantity);
        if (item.quantity === 0) {
          state.items = state.items.filter(
            (i) => i.id_product !== action.payload.id_product
          );
        }
      }

      state.total = state.items.reduce(
        (sum, item) => sum + item.price * item.quantity,

        0
      );
      state.totalQuantity = state.items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );
    }, */
    clearCart: (state) => {
      state.items = [];
      state.total = 0;
      state.totalQuantity = 0;
      state.id_delivery_type = 0;
      state.status = "pendiente";
      toast.error("El producto se ha removido del carrito!");
    },
  },
});

export const {
  addItem,
  removeItem,
  /*  updateQuantity, */
  clearCart,
  increaseQuantity,
  decreaseQuantity,
  addAdicionalCost,
  setDeliveryType,
} = cartSlice.actions;
export default cartSlice.reducer;
